export const DEFAULT_MAINTENANCE_MESSAGE =
    'Het platform is tijdelijk niet beschikbaar vanwege onderhoud. We werken aan een oplossing.'

export const DEFAULT_MAINTENANCE_STATUS_POLL_INTERVAL_MS = 30_000

export const DEFAULT_MAINTENANCE_STATUS_API_PATH = '/api/maintenance-status'
